export default "__VITE_ASSET__CohU6KPz__"